import { FlexCol } from "@design-system/Layout/Flex";
import { getSortedRowModel, Table } from "@design-system/Table";
import { Text } from "@design-system/Typography/Text";
import { RecentFrameworkProject } from "@generated/client/graphql";
import { type FC } from "react";
import { useRecentFrameworkProjectsTranslations } from "../i18n";
import { columns } from "./columns";

export const RecentFrameworkProjectTable: FC<{
    recentFrameworkProjects: RecentFrameworkProject[];
}> = ({ recentFrameworkProjects }) => {
    const tableOptions = {
        getSortedRowModel: getSortedRowModel(),
    };

    return (
        <Table
            columns={columns}
            options={tableOptions}
            data={recentFrameworkProjects}
            EmptyBody={EmptyState}
            variant="grid"
        />
    );
};

const EmptyState = () => {
    const { t, keys } = useRecentFrameworkProjectsTranslations();

    return (
        <FlexCol
            py="10"
            justifyContent="center"
            alignItems="center"
            w="full"
            className="bg-neutral-25"
        >
            <FlexCol gap="2" alignItems="center" className="my-8">
                <FlexCol gap="1" alignItems="center">
                    <Text variant="body-sm-bold">
                        {t(keys.empty_state_title)}
                    </Text>
                </FlexCol>
            </FlexCol>
        </FlexCol>
    );
};
